module.exports = __webpack_public_path__ + "img/symbol_9.ea9afc74.png";